import React, { useState } from 'react'
import FAQ from '../../components/FAQ'

import '../../styles/faq.css'
import home_bg from '../../assets/red_dragon2.png'
import project_bg from '../../assets/ww.png'
import target from '../../assets/target@2x.png'
import visionary from '../../assets/visionary@2x.png'
import red_lady from '../../assets/red_lady.png'
import HomePartners from '../../components/general/homepage/HomePartners'

const About = () => {
	const [faqs, setfaqs] = useState([
		{
			question: '1. How do I know if I qualify for funding?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
			open: true,
		},
		{
			question: '2. How do I Launch a project?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",

			open: false,
		},
		{
			question: '3. How do I know if I qualify for funding?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
			open: false,
		},
		{
			question: '4. How do I know if I qualify for funding?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
			open: false,
		},
	])

	const toggleFAQ = (index) => {
		setfaqs(
			faqs.map((faq, i) => {
				if (i === index) {
					faq.open = !faq.open
				} else {
					faq.open = false
				}

				return faq
			})
		)
	}

	let lists = [
		{
			image: target,
			text: 'OUR MISSION',
			info: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
		},
		{
			image: visionary,
			text: 'OUR VISION',
			info: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
		},
		{
			image: target,
			text: 'OUR MISSION',
			info: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
		},
	]

	return (
		<main className='about'>
			<section
				className='about_jumbo jumbo_section'
				style={{ background: `url(${home_bg})` }}
			>
				<div className='container'>
					<div className='d-flex about_jumbo_text'>
						<div>
							<h1>About Us</h1>
						</div>
					</div>
				</div>
			</section>

			<section
				className='about_welcome'
				style={{ background: `url(${project_bg})` }}
			>
				<div className='container'>
					<h6>WELCOME TO FEEMFUNDY</h6>
					<h1>Who We Are</h1>
					<p>
						<strong>FeemFUNDY</strong> is a crowdfunding platform where African
						filmmakers and funders collaborate to tell our African stories.
					</p>
					<p>
						Process: Filmmakers come to the platform and do a video and/or ppt
						pitch of their film and the public crowdfunds them. The platform
						also gives access to production resources (cast, crew, equipment,
						accommodation, locations, etc). Pls feel free to do research about
						some of the key film ecosystem members.
					</p>
				</div>
			</section>

			<section className='about_lists'>
				<div className='container'>
					<div className='row'>
						{lists.map((list) => (
							<div className='col-lg-4 col-md-6 ml-auto mr-auto'>
								<div className='about_lists_div'>
									<div className='d-flex justify-content-center'>
										<div className='text-center about_lists_div_box'>
											<img src={list.image} alt='' />
											<p> {list.text} </p>
										</div>
									</div>
									<p className='text-center'>{list.info}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className='about_faq'>
				<div className='container'>
					<div className='row'>
						<div className='col-lg-6 col-md-12'>
							<div className='faq_img'>
								<img src={red_lady} alt='' className='' />
							</div>
						</div>
						<div className='col-lg-6 col-md-12'>
							<div className='faqs'>
								<h5 className='text-center text-white'>FAQ</h5>
								{faqs.map((faq, i) => (
									<FAQ faq={faq} index={i} toggleFAQ={toggleFAQ} />
								))}
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className='about_welcome'>
				<div className='container'>
					<h6>INFORMATION</h6>
					<h1>What We Do</h1>

					<div className='row'>
						<div className='col-md-6'>
							<p>
								Lorem Ipsum is simply dummy text of the printing and typesetting
								industry. Lorem Ipsum has been the industry's standard dummy
								text ever since the 1500s, when an unknown printer took a galley
								of type and scrambled it to make a type specimen book. It has
								survived not only five centuries, but also the leap into
								electronic typesetting, remaining essentially unchanged.
							</p>
						</div>
						<div className='col-md-6'>
							<p>
								Lorem Ipsum is simply dummy text of the printing and typesetting
								industry. Lorem Ipsum has been the industry's standard dummy
								text ever since the 1500s, when an unknown printer took a galley
								of type and scrambled it to make a type specimen book. It has
								survived not only five centuries, but also the leap into
								electronic typesetting, remaining essentially unchanged. It was
								popularised in the 1960s with the release of Letraset sheets
								containing Lorem Ipsum passages, and more recently with desktop
								publishing software like Aldus PageMaker including versions of
								Lorem Ipsum.
							</p>
						</div>
					</div>
				</div>
			</section>

			<section className='about_partners'>
				<div className='container'>
					<h3 className='text-center page_header mb-0'>Our Partners</h3>
				</div>
				<HomePartners />
			</section>
		</main>
	)
}

export default About
